import React, { Component } from "react";
import { DKLabel, DKButton } from "deskera-ui-library";

import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DataGridHolder from "../common/DataGridHolder";
import { TABLES } from "../../managers/TableManger";
import LandingPageManager from "./LandingPageManager";
import AppManager from "../../managers/AppManager";
import TemplateManager from "./templates/TemplateManager";

export default class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    LandingPageManager.setPageData(null);
  }

  render() {
    return (
      <div className="parent-width">
        {/* <DKLabel text="Landing Pages" className="fw-m fs-l" /> */}
        <div className="column bg-deskera-secondary p-r border-radius-m border-m banner-holder">
          <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about creating & managing landing pages.' />

          <div className="row mt-r ml-l">
            <DKButton
              className="border-m bg-white"
              title="Read"
              onClick={AppManager.showComingSoonWarning}
            />
            <DKButton
              className="border-m ml-r bg-white"
              title="Watch"
              onClick={AppManager.showComingSoonWarning}
            />
          </div>
        </div>
        <div className="column mt-l parent-width mb-xl position-relative ">
          <DataGridHolder
            tableName={TABLES.PEOPLE_EMAIL_TEMPLATE}
            allowRowEdit={true}
            allowSearch={true}
            allowFilter={true}
            allowColumnAdd={true}
            allowColumnEdit={true}
            onRowEdit={(data) => {
              let data_formatted = {};
              data_formatted.data = {
                _id: data.rowData.id,
                cells: data.rowData,
              };
              LandingPageManager.setPageData(data_formatted);
              RouteManager.navigateToPage(
                PAGE_ROUTES.LANDING_PAGE_BUILDER + "/" + data.rowData.id
              );
            }}
            allowRowAdd={true}
            addButtonConfig={{
              title: "+ New Page",
              className: "bg-app text-white",
              onClick: () => {
                LandingPageManager.setPageData(null);
                TemplateManager.setSelectedTemplateId(null);
                RouteManager.navigateToPage(
                  PAGE_ROUTES.SELECT_LANDING_PAGE_TEMPLATE
                );
              },
            }}
          />
        </div>
      </div>
    );
  }
}
